module.exports = __webpack_public_path__ + "img/150.a48a145e.jpg";